import { render, staticRenderFns } from "./PendingUser.vue?vue&type=template&id=4da89fa8&scoped=true&"
import script from "./PendingUser.vue?vue&type=script&lang=js&"
export * from "./PendingUser.vue?vue&type=script&lang=js&"
import style0 from "./PendingUser.vue?vue&type=style&index=0&id=4da89fa8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da89fa8",
  null
  
)

export default component.exports